import { Link } from 'gatsby';

export const social = {
  twitter: 'https://twitter.com/smallplanetapps',
  twitterHandle: '@smallplanetapps',
  facebook: 'https://www.facebook.com/SmallPlanetDigital',
  instagram: 'https://instagram.com/smallplanetdigital',
  linkedin: 'https://www.linkedin.com/company/small-planet-digital',
  github: 'https://github.com/SmallPlanet'
};

export const isRelativeLink = link => link.startsWith('/');

export const isMailToLink = link => link.startsWith('mailto');

export const getLinkProps = link => {
  const isRelative = isRelativeLink(link);
  const targetProps = isMailToLink(link)
    ? {}
    : { target: '_blank', rel: 'noopener noreferrer' };

  return isRelative
    ? {
        as: Link,
        to: link,
        partiallyActive: true
      }
    : {
        as: 'a',
        href: link,
        ...targetProps
      };
};
